import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../containers';
import { Navbar } from '../../components';
import './YpologismosMoriwn.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../assets/OEFE.jpg';
import labora from '../../assets/labora.jpg';
import edu4schools from '../../assets/edu4schools.png';
import ypourgeio from '../../assets/ypourgeio.jpg';

const Ypologismos = () => {
  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };
  return (
    <div className="Ypologismos">
        <div className="gradient__bg">
          <Navbar className="navbar"/>
        </div>
        <div className="Ypologismos__main-container">
          <div className="Ypologismos__container">
            <div className="Ypologismos__container-h">
              <h1>Υπολογισμός Μορίων</h1>
            </div>
            <div className="Ypologismos__container-p">
              <p>&nbsp;&nbsp;&nbsp;ΠΑΤΉΣΤΕ <a href="https://markcalc.it.minedu.gov.gr/" target="_blank" rel="noopener noreferrer" style={{ color: '#05B2DC', textDecoration: 'underline' }}>ΕΔΩ</a> ΓΙΑ ΝΑ ΥΠΟΛΟΓΙΣΕΤΕ ΤΑ ΜΟΡΙΑ ΣΑΣ:</p>
              <h2>&nbsp;&nbsp;&nbsp;&nbsp;ΣΧΕΤΙΚΑ ΜΕ ΤΟΝ ΤΡΟΠΟ ΥΠΟΛΟΓΙΣΜΟΥ ΜΟΡΙΩΝ</h2>
              <p>&nbsp;&nbsp;&nbsp;Σύμφωνα με το άρθρο του υπουργείο παιδείας, ο υπολογισμός του συνολικού αριθμού μορίων κάθε υποψηφίου που συμμετέχει στις πανελλαδικές εξετάσεις  του τρέχων έτους  και εφεξής για εισαγωγή στις Σχολές, τα Τμήματα και τις Εισαγωγικές Κατευθύνσεις Τμημάτων, γίνεται ως εξής: ο γραπτός βαθμός σε καθένα από τα τέσσερα (4) πανελλαδικά εξεταζόμενα μαθήματα τα οποία προβλέπονται στην Ομάδα Προσανατολισμού όπου ανήκει ο υποψήφιος για το συγκεκριμένο Επιστημονικό Πεδίο, πολλαπλασιάζεται με τον αντίστοιχο συντελεστή βαρύτητας, όπως αυτός ορίστηκε με την υπό στοιχεία Φ.253.1/148469/Α5/18-11-2021 (Β΄5399) ΥΑ «Καθορισμός των συντελεστών βαρύτητας των πανελλαδικά εξεταζόμενων μαθημάτων ΓΕΛ, των ειδικών μαθημάτων και πρακτικών δοκιμασιών … το ακαδημαϊκό έτος 2022-2023 και εφεξής.». Τα τέσσερα (4) ανωτέρω γινόμενα προστίθενται και το τελικό άθροισμα πολλαπλασιάζεται επί χίλια (1000), για να προκύψει έτσι ο συνολικός αριθμός μορίων κάθε υποψηφίου για κάθε Σχολή, Τμήμα ή Εισαγωγική Κατεύθυνση Τμήματος. Ο βαθμός κάθε πανελλαδικά εξεταζόμενου μαθήματος εκφράζεται στην εικοσάβαθμη κλίμακα με προσέγγιση δεκάτου. Σημειώνεται ότι οι συντελεστές βαρύτητας ανά μάθημα</p>
            </div>
          </div>
          <div className="Ypologismos__side-Containers">
              <div className="Ypologismos__side-Container1">
                <h1>Χρήσιμες Σελίδες</h1>
                <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
              </div>
              <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
            </div>
            </div>
        <Footer />
    </div>
  )
}

export default Ypologismos